// The tour is for people who join after it shipped. Everyone already using
// CounselPro by then knows the app, so they never see it.
export const GETTING_STARTED_LAUNCHED_AT = '2026-10-15T00:00:00Z'

export const joinedAfterLaunch = (userCreatedAt: string | null) =>
  userCreatedAt !== null &&
  new Date(userCreatedAt).getTime() >=
    new Date(GETTING_STARTED_LAUNCHED_AT).getTime()
